<template>
  <div class="home">
    <oto-navbar
      :titleObj="titleObj"
      :title="title"
    />
    <mainContent class="mainContentComp" @getMerchantName="getMerchantName" />
    <footerBox />
  </div>
</template>

<script>
// @ is an alias to /src
import otoNavbar from '@/components/otoNavbar.vue'
import footerBox from '@/components/footer.vue'
import mainContent from './component/mainContent'

export default {
  name: 'merchant',
  data () {
    return {
      titleObj: {},
      title: ''
    }
  },
  methods: {
    getMerchantName (name) {
      this.titleObj.key = name
      this.titleObj.value = name
      this.titleObj.path = '/merchant/oto'
      this.title = name
    }
  },
  components: {
    otoNavbar,
    footerBox,
    mainContent
  }
}
</script>
<style scoped>
.home {
  min-height: 100%;
  display:flex;
  flex-direction: column;
  background: #ffffff;
}
.mainContentComp{
  flex: 1;
  width: 100%;
}
</style>
<style>
#app{
  height: 100%;
}
</style>